import { lazy } from 'react';
import {
    BlockWrapper,
    ChildrenBlock,
    defineBlock,
    smartProps,
    useEditor,
    useInspectorControl,
} from '@smartfire/js-block-engine';
import { EditableHeading } from '@smartfire/components';
import style from './style.module.scss';
import clsx from 'clsx';

const Inspector = lazy(() => import('./inspector.js'));

const Block = ({ background, title, ...props }) => {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.Div
            className={clsx(style.block, isEditing && style.isEditing, background && style.background, props.className)}
            style={{ backgroundImage: background ? 'url(' + background.url + ')' : null }}
        >
            <div className={style.content}>
                {typeof title === 'string' ? (
                    <h1 className={style.title}>{title}</h1>
                ) : (
                    (isEditing || (title && title.content)) && (
                        <EditableHeading className={style.title} smartProp={'title'} />
                    )
                )}
                <ChildrenBlock
                    key="children"
                    gutenbergEditorConfig={{
                        orientation: 'vertical',
                        allowedBlocks: ['core/paragraph', 'smartfire/spacer', 'smartfire/button'],
                    }}
                />
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Block,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 1,
            content: '',
        }),
        background: smartProps.image,
    },
    setup: {
        title: 'Bandeau header',
    },
});
